'use es6';
/* eslint-disable */

import _ from 'underscore';
/*
 * Borrowed from
 *  https://github.com/documentcloud/underscore-contrib/blob/master/underscore.object.selectors.js
 *
 * TODO: Faast team is looking at a longer term solution.
 * Limiting export to just `getPath` and `hasPath` for now.
 */
// Underscore-contrib (underscore.object.selectors.js 0.3.0)
// (c) 2013 Michael Fogus, DocumentCloud and Investigative Reporters & Editors
// Underscore-contrib may be freely distributed under the MIT license.
// Helpers
// -------
// Create quick reference variables for speed access to core prototypes.

var concat = Array.prototype.concat;
var ArrayProto = Array.prototype;
var slice = ArrayProto.slice; // Will take a path like 'element[0][1].subElement["Hey!.What?"]["[hey]"]'
// and return ["element", "0", "1", "subElement", "Hey!.What?", "[hey]"]

export function keysFromPath(path) {
  // from http://codereview.stackexchange.com/a/63010/8176

  /**
   * Repeatedly capture either:
   * - a bracketed expression, discarding optional matching quotes inside, or
   * - an unbracketed expression, delimited by a dot or a bracket.
   */
  var re = /\[("|')(.+)\1\]|([^.\[\]]+)/g;
  var elements = [];
  var result;

  while ((result = re.exec(path)) !== null) {
    elements.push(result[2] || result[3]);
  }

  return elements;
}
export function getPath(obj, ks) {
  ks = typeof ks == 'string' ? keysFromPath(ks) : ks;
  var i = -1,
      length = ks.length; // If the obj is null or undefined we have to break as
  // a TypeError will result trying to access any property
  // Otherwise keep incrementally access the next property in
  // ks until complete

  while (++i < length && obj != null) {
    obj = obj[ks[i]];
  }

  return i === length ? obj : void 0;
}
export function hasPath(obj, ks) {
  ks = typeof ks == 'string' ? keysFromPath(ks) : ks;
  var i = -1,
      length = ks.length;

  while (++i < length && _.isObject(obj)) {
    if (ks[i] in obj) {
      obj = obj[ks[i]];
    } else {
      return false;
    }
  }

  return i === length;
}
/* eslint-env commonjs */
// This temporary hack ensures module system compatibility.
// Read more at go/treeshaking

if (!!module && !!module.exports) {
  module.exports.default = Object.assign({}, module.exports);
}